module.exports = __webpack_public_path__ + "img/subtitle3.48c3f76d.png";